import { cookieExists } from '../util/common';
import NewsletterPopup from './../homepage/newsletterPopup';

let newPopupModalHidden = false;
const modalVisibleClass = 'newsletterPopupVisible';
const modalHiddenClass = 'newsletterPopupHidden';
let newsletterPopupLeftMargin = '0px';
const newsletterWrapperElement = document.createElement('DIV');

class NewsletterPopupNew {
    init () {
        if (!window.SitePreferences.NewsletterPopupEnabled) {
            return false;
        }

        if (window.location.href.indexOf('tezenis') && $('.page').data('action').indexOf('Home-Show') > -1) {
            if (window.location.href.indexOf('newsletterNew') > -1) {
                newsletterPopupDismissed();
            } else {
                if (cookieExists('fpls_ga_bnd') && !localStorage.getItem('newsletterPopup')) {
                    initNewsletterPopupShow();
                } else {
                    initCookieAcceptedNewsletterPopupShowListener();
                }
            }
        }
    }
}

function initCookieAcceptedNewsletterPopupShowListener () {
    $('body').on('click', '[id="onetrust-close-btn-container"]', (e) => {
        initNewsletterPopupShow();
    });
    $('body').on('click', '[id="onetrust-accept-btn-handler"]', (e) => {
        initNewsletterPopupShow();
    });
}

function initNewsletterPopupShow () {
    setTimeout(function () {
        showNewsletterPopup();
    }, 5000);
}

function showNewsletterPopup () {
    const url = window.Urls.getNewsletterPopupNew;

    if (url) {
        $.ajax({
            url: url,
            type: 'get',
            success: function (data) {
                newsletterWrapperElement.id = 'new-newsletter-popup-wrapper';
                newsletterWrapperElement.classList.add('custom-newsletter-popup-new');
                newsletterWrapperElement.classList.add(modalVisibleClass);
                newsletterWrapperElement.innerHTML = data;
                newsletterWrapperElement.style.left = '-999px';

                document.body.insertBefore(newsletterWrapperElement, document.body.firstChild);
                if (window.innerWidth > 800) {
                    newsletterPopupLeftMargin = '2.30769rem';
                    $('#new-newsletter-popup-wrapper').animate({ left: '2.30769rem' }, 'slow');
                } else {
                    newsletterPopupLeftMargin = '0px';
                    $('#new-newsletter-popup-wrapper').animate({ left: '0px' }, 'slow');
                }

                document.getElementById('new-newsletter-popup-close').addEventListener('click', function (e) {
                    $('#new-newsletter-popup-wrapper').animate({ left: '-999px' }, 'slow', function () {
                        let popupToRemove = document.getElementById('new-newsletter-popup-wrapper');
                        document.body.removeChild(popupToRemove);
                        window.removeEventListener('resize', onResizeNewsletterFix);
                        window.removeEventListener('scroll', onScrollNewsletterFix);
                    });
                });
                document.getElementById('new-newsletter-popup-button').addEventListener('click', function (e) {
                    e.preventDefault();
                    $('#new-newsletter-popup-wrapper').animate({ left: '-999px' }, 'slow', function () {
                        window.removeEventListener('resize', onResizeNewsletterFix);
                        window.removeEventListener('scroll', onScrollNewsletterFix);
                    });
                    $('#newsletterFooterForm').data('which-form', 'newsletter-new');
                    NewsletterPopup.showPopup();
                    $('body').trigger('footer:NewsletterStep1');
                });

                window.addEventListener('resize', onResizeNewsletterFix);
                window.addEventListener('scroll', onScrollNewsletterFix);
                newsletterPopupDismissed();
            },

            error: function (err) { }
        });
    }
}

function newsletterPopupDismissed () {
    window.localStorage.setItem('newsletterPopup', '1');
}

function onResizeNewsletterFix (e) {
    if (!newPopupModalHidden) {
        if (window.innerWidth > 800) {
            newsletterPopupLeftMargin = '2.30769rem';
            newsletterWrapperElement.style.left = newsletterPopupLeftMargin;
        } else {
            newsletterPopupLeftMargin = '0px';
            newsletterWrapperElement.style.left = newsletterPopupLeftMargin;
        }
    }
}

function onScrollNewsletterFix (e) {
    let resolutionFooterBoundary = document.body.offsetHeight - Math.floor(document.getElementsByTagName('footer')[0].offsetHeight * 2.5);
    if (window.pageYOffset > resolutionFooterBoundary && newsletterWrapperElement.classList.contains(modalVisibleClass)) {
        newPopupModalHidden = true;
        newsletterWrapperElement.classList.remove(modalVisibleClass);
        $('#new-newsletter-popup-wrapper').animate({ left: '-999px' }, 'slow', function () {
            newsletterWrapperElement.classList.add(modalHiddenClass);
        });
    } else if (window.pageYOffset < resolutionFooterBoundary && newsletterWrapperElement.classList.contains(modalHiddenClass)) {
        newPopupModalHidden = false;
        newsletterWrapperElement.classList.remove(modalHiddenClass);
        $('#new-newsletter-popup-wrapper').animate({ left: newsletterPopupLeftMargin }, 'slow', function () {
            newsletterWrapperElement.classList.add(modalVisibleClass);
        });
    }
}

const newsletterPopupNew = new NewsletterPopupNew();
export default newsletterPopupNew;
